import { tabNames } from '@va/constants';
import { PageContent, PageHeader, TitleAndContextMenu } from '@va/dashboard/shared/ui-layout';
import { useActiveTab } from '@va/dashboard/util-hooks';
import { useTranslate } from '@va/localization';
import { QuickNavigator } from '@va/ui/design-system';
import { useElementDimensions } from '@va/util/hooks';
import classNames from 'classnames';
import { useRef } from 'react';

export const GeneralSettingsComponent = ({
  cards,
}: {
  cards: { id: string; title: string; subTitle?: string; component: React.ReactNode }[];
}) => {
  useActiveTab(tabNames.generalSettings);
  const pageContentRef = useRef<HTMLDivElement>(null);
  const translate = useTranslate();
  const { width: pageContentWidth } = useElementDimensions(pageContentRef);

  const showQuickNavigator = pageContentWidth > 1280;

  useActiveTab(tabNames.generalSettings);

  return (
    <>
      <PageHeader
        title={
          <TitleAndContextMenu
            title={translate('all.generalSettings.title')}
            tooltipTransKey={'tooltipTab.generalSettings'}
          />
        }
        hideDatePicker
      />
      <PageContent className='p-18px'>
        <div ref={pageContentRef} className='lg:flex lg:gap-60 relative'>
          <div
            className={classNames('absolute top-0 h-full left-0 transition-all duration-500', {
              '-translate-x-[18.75rem] opacity-0': !showQuickNavigator,
            })}
          >
            <QuickNavigator
              navigatorClass={'top-[calc(114px+var(--top-bar-height))] min-w-300 max-w-300'}
              list={cards}
              offset={180}
            />
          </div>
          <div className='lg:flex lg:grow lg:justify-center'>
            <div className={classNames('space-y-10 lg:max-w-600 transition-transform duration-500')}>
              {cards.map(({ id, component }) => (
                <div key={id} id={id} className='max-w-full'>
                  {component}
                </div>
              ))}
            </div>
          </div>
        </div>
      </PageContent>
    </>
  );
};
